// routes which require authentication
export const authRoutesAwards = [
  {
    path: '/awards/nominations',
    name: 'Nominations',
    component: () => import(/* webpackChunkName: "nominations-index" */ '../views/areas/awards/nominations/Index.vue'),
  },
  {
    path: '/awards/:award/nominations/create',
    name: 'NominationsCreate',
    component: () => import(/* webpackChunkName: "nominations-create" */ '../views/areas/awards/nominations/Create.vue'),
  },
  {
    path: '/awards/nominations/:nomination',
    name: 'NominationsEdit',
    component: () => import(/* webpackChunkName: "nominations-create" */ '../views/areas/awards/nominations/Edit.vue'),
    meta: {
      breadcrumbParent: {
        path: '/awards/nominations',
        text: 'Nominations',
      },
    },
  },
  {
    path: '/awards/references',
    name: 'References',
    component: () => import(/* webpackChunkName: "references-index" */ '../views/areas/awards/references/Index.vue'),
  },
  {
    path: '/awards/references/:reference',
    name: 'ReferencesEdit',
    component: () => import(/* webpackChunkName: "references-edit" */ '../views/areas/awards/references/Edit.vue'),

    meta: {
      breadcrumbParent: {
        path: '/awards/references',
        text: 'References',
      },
    },
  },
  {
    path: '/awards/evaluations',
    name: 'Reviews',
    component: () => import(/* webpackChunkName: "reviews-index" */ '../views/areas/awards/reviews/Index.vue'),
  },
  {
    path: '/awards/evaluations/:review',
    name: 'ReviewsEdit',
    component: () => import(/* webpackChunkName: "reviews-edit" */ '../views/areas/awards/reviews/Edit.vue'),
    meta: {
      breadcrumbParent: {
        path: '/awards/evaluations',
        text: 'Evaluations',
      },
    },
  },
  {
    path: '/awards/decisions',
    name: 'Decisions',
    component: () => import(/* webpackChunkName: "decisions-index" */ '../views/areas/awards/decisions/Index.vue'),
  },
  {
    path: '/awards/reports/:report',
    name: 'ReportsEdit',
    component: () => import(/* webpackChunkName: "reports-edit" */ '../views/areas/awards/reports/Edit.vue'),
    meta: {
      breadcrumbParent: {
        path: '/awards/decisions',
        text: 'Decisions',
      },
    },
  },
];

export const guestRoutesAwards = [
  {
    path: '/awards',
    name: 'Awardees',
    component: () => import(/* webpackChunkName: "awards-index" */ '../views/areas/awards/Index.vue'),
  },
];
